import { AppManager, assetDir } from '@common';
import * as PANOLENS from 'panolens';
import * as THREE from 'three';
import { textSprite, textSpriteTexture, textSpriteUpdateScale } from '../utils/textSprite';
import BaseInteractiveSpot from './BaseInteractiveSpot';

const labelScale = 0.3;
const labelStyle = {
  fontSize: 60,
  fontWeight: 800,
  fontFamily: 'font-en',
};

export default class InfoProductViewSpot extends BaseInteractiveSpot {
  constructor(panorama, config) {
    super(panorama);
    this.productViewConfig = config;

    if (this.labelImage) {
      new THREE.TextureLoader().load(this.labelImage, (tex) => {
        this.labelImageMesh = this.createLabelImageButton(tex);
      });
    } else {
      new THREE.TextureLoader().load(
        `${assetDir}/images/buttons/clickpoint.png`,
        (tex) => {
          this.buttonMesh = this.createButton(tex);
          this.labelMesh = this.createLabel();
        }
      );
    }
    
    this.panorama.addEventListener('change-language', this.onChangeLanguage.bind(this));
  }


  createButton(baseTex) {
    const info = new PANOLENS.Infospot(300, baseTex, false, {
      onHoverStart: this.onHoverStart,
      onHoverEnd: this.onHoverEnd,
      onTouchStart: this.onTouchStart,
    });
    info.position.fromArray(this.productViewConfig.position);
    info.addEventListener('click', this.onClick.bind(this));
    info.name = `productView-${this.label}`;
    this.panorama.add(info);
    return info;
  }


  createLabelImageButton(baseTex) {
    const info = new PANOLENS.Infospot(1500, baseTex, false, {
      onHoverStart: this.onHoverStart,
      onHoverEnd: this.onHoverEnd,
      onTouchStart: this.onTouchStart,
    });
    info.position.fromArray(this.productViewConfig.position);
    info.addEventListener('click', this.onClick.bind(this));
    info.name = `productView-${this.label}`;
    this.panorama.add(info);
    return info;
  }


  createLabel() {
    const labelSprite = textSprite(this.label, labelScale, labelStyle);
    labelSprite.name = `productViewLabel-${this.label}`;
    this.buttonMesh.addLabel(labelSprite);
    return labelSprite;
  }


  onClick(event) {
    const { action } = this.productViewConfig;
    this.actionHandler(action);
  }


  onChangeLanguage() {
    if (this.labelImageMesh && this.labelImageMesh.material) {
      new THREE.TextureLoader().load(this.labelImage, tex => {
        this.labelImageMesh.material.map = tex;
      });
    }
    if (this.labelMesh && this.labelMesh.material) {
      this.labelMesh.material.map = textSpriteTexture(this.label, labelStyle);
      textSpriteUpdateScale(this.labelMesh, labelScale);
    }
  }


  onHoverStart(info) {
    info.material.color.set('#bbb');
  }


  onHoverEnd(info) {
    info.material.color.set('#fff');
  }


  get label() {
    if (this.productViewConfig['label_' + AppManager.currentLanguage]) {
      return this.productViewConfig['label_' + AppManager.currentLanguage];
    }
    return this.productViewConfig.label;
  }


  get labelImage() {
    if (this.productViewConfig.linkLabelImage) {
      return AppManager.convertToLocalizedPath(this.productViewConfig.linkLabelImage);
    }
    return null;
  }

}